/// <reference path="../_references.ts"/>

module App.Helpers {
	export class LocationService {
		constructor(public $q: ng.IQService){}

		public getLocation(): ng.IPromise<Coordinates> {
			let defer: ng.IDeferred<Coordinates> = this.$q.defer();

			navigator.geolocation.getCurrentPosition((pos) => {
				defer.resolve(pos.coords);
			}, (err) => {
				defer.resolve({
					latitude: null,
					longitude: null,
				});
			}, {
				maximumAge: 60000,
				timeout: 10000,
				enableHighAccuracy: true
			});

			return defer.promise;
		}

		static factory() {
			let instance = ($q: ng.IQService) =>
				new LocationService($q);

			instance.$inject = ['$q'];
			return instance;
		}
	}

	angular
		.module('helpers.locationService', [])
		.factory('LocationService', LocationService.factory());
}
